import React from "react";
import leftPathIcon from "../../assets/images/left-path.svg";
import darkLogoOnly from "../../assets/images/logos/logo-only-theme-dark.svg";
import rightPathIcon from "../../assets/images/right-path.svg";
import { Localized } from "../../strings";
import AppStyles from "../App.module.css";
import Styles from "./CenteredContentWithLogo.module.css";

export const CenteredContentWithLogo: React.FunctionComponent<
  React.PropsWithChildren
> = ({ children }) => {
  const strings = Localized.object("CENTERED_CONTENT_WITH_LOGO");
  return (
    <div className={AppStyles.hideScrollbar}>
      <img
        alt={strings.LEFT_PATH_ICON}
        className={Styles.leftPath}
        src={leftPathIcon}
      />
      <div className={Styles.centered}>
        <div className={Styles.content}>
          <img
            alt={strings.HOYLU_LOGO}
            className={Styles.hoyluLogo}
            src={darkLogoOnly}
          />
          {children}
        </div>
        <img
          alt={strings.RIGHT_PATH_ICON}
          className={Styles.rightPath}
          src={rightPathIcon}
        />
      </div>
    </div>
  );
};
